<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim :options="notfound" class="anim" :height="getScreen ? 200 : 500" :width="getScreen ? 200 : 500"></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/bidBondRequest">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              Manifest Request Guarantee
              <small class="m-display-block m-text-small">{{
                data.header.no_trans
              }}</small>
            </div>

            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <!-- <li>
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    @click="handlePrint"
                    class="m-display-block"
                    >Manifest</a-button
                  >
                </li> -->
                <li v-if="getAuth.username == data.header.tlc_create">
                  <!-- <a-button-group> -->
                  <a-button :disabled="!(
                    data.last_status == 'Revised' &&
                    getAuth.username == data.header.tlc_create
                  )
                    " @click="handleEdit" type="dashed" size="small" icon="edit" block
                    class="m-display-block">Edit</a-button>
                  <!-- </a-button-group> -->
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date guarantee</span>
                  <span class="m-list-desc">{{
                    data.header.date_guarantee
                    ? moment(
                      data.header.date_guarantee,
                      getStandartFormatDate
                    ).format(getDefaultDateFormat)
                    : "-"
                  }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>TLC Create</span>
                  <span class="m-list-desc">{{ data.header.tlc_create }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bank Site</span>
                  <span class="m-list-desc">{{ data.header.location }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Guarantee Period</span>
                  <span class="m-list-desc">{{
                    data.header.start_due_dt
                    ? moment(
                      data.header.start_due_dt,
                      getStandartFormatDate
                    ).format(getDefaultDateFormat)
                    : ""
                  }} ~ {{
  data.header.end_due_dt
  ? moment(
    data.header.end_due_dt,
    getStandartFormatDate
  ).format(getDefaultDateFormat)
  : ""
}}
                  </span>
                </li>
                <li v-if="data.header.type.toLowerCase() == 'as companion'">
                  <span class="m-list-title" for>Nominal</span>
                  <span class="m-list-desc">{{ formatCurrency("IDR", data.header.nominal) }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Project Name</span>
                  <span class="m-list-desc">{{ data.header.name_project }}</span>
                </li>
                <li v-if="data.header.recieve_project">
                  <span class="m-list-title" for>
                    {{ data.header.type == 'As Companion' ? 'Receiver Project' : 'Companion Name' }}
                  </span>
                  <span class="m-list-desc">{{ data.header.recieve_project }}</span>
                </li>
                <li v-if="data.header.contact_person">
                  <span class="m-list-title" for>Contact Person</span>
                  <span class="m-list-desc">{{ data.header.contact_person }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Obligee Name</span>
                  <span class="m-list-desc">{{ data.header.obligee_nm }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Obligee Address</span>
                  <span class="m-list-desc">{{ data.header.obligee_address }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Category</span>
                  <span class="m-list-desc">{{ "Jaminan " + data.header.kategori_jaminan }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.header.note }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Type</span>
                  <span class="m-list-desc">{{ data.header.type }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>File Attachment</span>
                  <span class="m-list-desc margin-top">
                    <a-button class="margin-top ant-menu-submenu ant-menu-submenu-selected" icon="download" size="default"
                      @click="handlePreview(data.header.file_attachment)">View Document</a-button>

                  </span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-collapse v-if="data.header.type.toLowerCase() == 'as winner'" :class="!getScreen ? 'margin-top' : ''"
            activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Companion List</h4>
              <a-input-search v-model="search" placeholder="Quick Search" allowClear class="margin-bottom" />
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table key="table_1" :rowKey="(record, index) => { return index; }" :columns="columns"
                  :dataSource="tableData" :pagination="pagination" size="small" bordered :scroll="{ x: 950 }">
                  <template slot="companion_nm" slot-scope="item">
                    <span>{{ item.companion_nm }}</span><br />
                    <small>[ Type : {{ item.type_dtl ? item.type_dtl : "-" }} ]</small>
                  </template>
                  <template slot="contact_person" slot-scope="item">
                    <span>{{ item.contact_person }}</span><br />
                  </template>
                  <template slot="nominal" slot-scope="item">
                    <div style="float:right">
                      <span>{{ formatCurrency('IDR', item) }}</span>
                    </div>
                  </template>
                  <template slot="return_dt" slot-scope="item">
                    <span>{{ moment(item.return_dt).format(getDefaultDateFormat) }}</span><br />
                  </template>
                  <a slot="no_bkk" slot-scope="item" @click="handleLink('bkk', item.bkk_id)">{{ item.no_bkk }}</a>
                  <a slot="bidbond_no" slot-scope="item" @click="handleLink('bidbond', item.bidbond_id)">{{
                    item.bidbond_no }}</a>
                </a-table>
              </a-config-provider>
            </a-collapse-panel>
          </a-collapse>

          <a-card class="margin-top" :loading="loading" v-if="data.jenis === 'Approve'">
            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['catatan']" />
              </a-form-item>
              <a-form-item label="Actions">
                <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" :loading="loadingSave" block type="primary"
                  html-type="submit">Save</a-button>
              </a-form-item>
            </a-form>
          </a-card>
          <a-card class="margin-top" v-if="data.jenis === 'Transfer' && status_transfer">
            <div slot="title">
              Manifest Actions &nbsp;<i v-if="data.jenis == 'Transfer' && !status_transfer"
                style="color: red !important">(Funding has not been set)</i>
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(data.currency, sisa_tf)
              }}</a-tag>
            </div>
            <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
              <a-form :form="formTransfer">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select @change="onChangeStatus" v-decorator="[
                      'aksi',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]">
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker placeholder="Select Date" :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]" />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload :fileList="fileList" :showUploadList="true" :disabled="fileList.length > 0" v-decorator="[
                      'file_transfer',
                      { rules: [{ required: reqFileTf }] },
                    ]" accept=".jpg, .png, .pdf" :remove="handleRemove" :beforeUpload="beforeUpload">
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox :defaultChecked="true" @change="onchangeNilaiTf" :checked="checkTransferValue">Transfer
                      value according to remaining balance</a-checkbox>
                    <a-input-number :min="0.1" :max="sisa_tf" class="m-display-block" style="width:150px" v-decorator="[
                      'value_transferan',
                      {
                        rules: [{ required: true }],
                        initialValue: temp_sisa_tf,
                      },
                    ]" :disabled="disableNilaiTf" @keydown="onlyNumber"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\\s?|(,*)/g, '')"></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="[
                      'catatan',
                      { rules: [{ required: false }] },
                    ]" />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button @click="handleAction" block type="primary" html-type="submit">Save</a-button>
                </a-form-item>
              </a-form>
            </template>
          </a-card>
        </a-col>

        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="loading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">Evidence of Transfer</div>
            <div>
              <a-alert v-if="data.bukti_transfer.length <= 0" type="error" message="No evidence of transfer was uploaded"
                banner />
              <a-list itemLayout="horizontal" :dataSource="data.bukti_transfer" v-else>
                <Empty v-if="data.bukti_transfer
                  ? data.bukti_transfer.length <= 0
                  : data.bukti_transfer
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h3 class="margin-remove">
                        {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                      </h3>


                      <h4 class="margin-remove">
                        {{ formatCurrency(data.mata_uang, item.value_tf) }}
                      </h4>
                    </div>
                    <img class="m-image-icon" slot="avatar" :src="$serviceUrl + item.url" />\
                    <p slot="description" class="margin-remove">
                      {{ item.user_tf }}
                      <br />
                      <a-button @click="handleViewDt(item)" size="small" type="default" icon="eye">View</a-button>
                    </p>

                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>

          <a-card class="margin-top" v-if="data.header.type != 'As Winner'">
            <div slot="title">
              <span>Evidence Incoming Transfer</span>
            </div>
            <a-button @click="attachment = true" type="default" slot="extra" :disabled="disabledUpload">
              <a-icon type="upload" />
            </a-button>

            <a-list itemLayout="horizontal" :dataSource="data.buktiTransferMasuk">
              <Empty v-if="data.buktiTransferMasuk ? data.buktiTransferMasuk.length <= 0 : data.buktiTransferMasuk" />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <!-- <a
                      @click="handleDownload(item)"
                      class="margin-remove m-text-dots"
                    >
                      {{ item.jenis ? item.jenis : "-" }}
                    </a> -->
                  </div>
                  <div slot="description">
                    <div class="m-display-flex space-between nowrap align-middle">
                      <div>
                        <h4 class="margin-remove m-text-dots">
                          {{ item.description }}
                        </h4>
                        {{ item.tgl_tf }} | {{ item.user_tf }}
                        <div>
                          {{ formatCurrency('IDR', item.value_tf) }}
                        </div>
                      </div>
                      <!-- <a-button
                        v-if="data.header.tlc_create === getAuth.username"
                        @click="handleRemoveExisting(item.id_po_doc)"
                        size="small"
                        type="danger"
                        icon="delete"
                      ></a-button> -->
                      <a-button type="primary" @click="handlePreview(item.url)" icon="eye">
                      </a-button>
                    </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card>

          <a-collapse activeKey="1" class="margin-top">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <!-- <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button> -->
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.header.tlc_create }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.header.date_guarantee).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.header.note">{{
                      data.header.note
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item v-for="workflow in data.status" :key="workflow.step_no">
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse :class="'margin-top'" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Document PP</h4>
                <a-button icon="plus" size="small" type="primary" class="margin-right" @click="showModalAddPP"
                  v-if="data.header.tlc_create == getAuth.username"></a-button>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.document_pp">
                <Empty v-if="data.document_pp
                  ? data.document_pp.length <= 0
                  : data.document_pp
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <a @click="
                        handleView({
                          ...item,
                          id_manifest: item.id_manifest,
                        })
                        ">{{ item.no_trans }}</a>
                    </div>
                    <template slot="description">
                      <div>{{ item.description }}</div>
                      <div>{{ item.tgl }}</div>
                      <div>{{ formatCurrency("", item.estimated_value) }}</div>
                      <div>{{ item.deskripsi }}</div>
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse :class="'margin-top'" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.related_document">
                <Empty v-if="data.related_document
                  ? data.related_document.length <= 0
                  : data.related_document
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <a @click="
                        handleView({
                          ...item,
                          id_manifest: item.id_manifest,
                        })
                        ">{{ item.no_trans }}</a>
                    </div>
                    <template slot="description">
                      <div>{{ item.description }}</div>
                      <div>{{ formatCurrency("", item.value_bkk) }}</div>
                      <div>{{ item.tgl }}</div>
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

        </a-col>
      </a-row>
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-modal @ok="handleUploadDoc" :confirmLoading="attachmentForm.loading" okText="Submit" cancelText="Cancel"
      title="Evidence Incoming Transfer" centered v-model="attachment">
      <a-form-model ref="attachmentForm" :model="attachmentForm" :rules="attachmentRules">
        <a-form-model-item label="Upload File" prop="file">
          <a-upload :fileList="attachmentForm.file" :beforeUpload="uploadAttachment" :remove="onRemoveAttachment"
            v-model="attachmentForm.file">
            <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="Value" prop="value">
          <a-input-number v-model="attachmentForm.value" class="m-width-full" :min="0" @keydown="onlyNumber" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" />
        </a-form-model-item>
        <a-form-model-item label="Description" prop="description">
          <a-textarea v-model="attachmentForm.description" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-if="modalPP.visible" :visible="modalPP.visible" @cancel="unShowModalAddPP" title="Input Document PP"
      centered :maskClosable="false">
      <a-form-item label="No PP" required>
        <v-select class="m-select" :clearable="false" :options="modalPP.listPP" v-model="modalPP.ppValue"
          @input="inputppValue" placeholder="Select No PP" label="no_pp"></v-select>
      </a-form-item>
      <div slot="footer">
        <a-button type="primary" icon="save" @click="saveModalAddPP" :loading="modalPP.loadingSave">SAVE</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "bidBondRequestManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      notfound: { animationData: notfound, loop: true },
      loading: false,
      data: {
        bukti_transfer: [],
        status: [],
        header: {
          type: "",
        },
        jenis: null,
        buktiTransferMasuk: [],
      },
      dateFormat: "DD-MM-YYYY",
      status_transfer: null,
      sisa_tf: 0,
      reqFileTf: true,
      fileList: [],
      checkTransferValue: true,
      temp_sisa_tf: "",
      disableNilaiTf: true,
      previewVisible: false,
      previewImage: "",
      loadingSave: false,
      attachment: false,
      attachmentForm: {
        loading: false,
        file: [],
        value: null,
        description: "",
      },
      attachmentRules: {
        file: {
          required: true,
          message: "please select your document",
          trigger: "change",
        },
        value: {
          required: true,
          message: "Value is required!",
          trigger: "change",
        },
        description: {
          required: true,
          message: "Description is required!",
          trigger: "change",
        },
      },
      disabledUpload: false,
      search: "",
      pagination: {
        onChange: (page) => { },
        pageSize: 10,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      modalPP: {
        visible: false,
        ppValue: null,
        loadingSave: false,
        listPP: [
          { key: "a", text: "jos" },
          { key: "b", text: "gandos" },
        ]
      }
    };
  },
  beforeCreate() {
    this.formTransfer = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getDateTimeFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Companion Name",
          scopedSlots: { customRender: "companion_nm" },
          key: "companion_nm",
          width: 350,
          sorter: (a, b) => a.companion_nm - b.companion_nm,
        },
        {
          title: "Contact Person",
          key: "contact_person",
          width: 200,
          scopedSlots: { customRender: "contact_person" },
          sorter: (a, b) => a.contact_person - b.contact_person,
        },
        {
          title: "Nominal",
          dataIndex: "nominal",
          key: "nominal",
          width: 200,
          align: "center",
          sorter: (a, b) => a.nominal - b.nominal,
          scopedSlots: { customRender: "nominal" },
        },
        {
          title: "Return Date",
          key: "return_dt",
          width: 200,
          align: "center",
          scopedSlots: { customRender: "return_dt" },
          sorter: (a, b) => a.return_dt - b.return_dt,
        },
        {
          title: "Note",
          key: "note",
          dataIndex: "note",
          width: 200,
          sorter: (a, b) => a.note - b.note,
        },
        {
          title: "No BKK",
          key: "no_bkk",
          width: 200,
          align: "left",
          sorter: (a, b) => a.no_bkk - b.no_bkk,
          scopedSlots: { customRender: "no_bkk" },
        },
        {
          title: "No Guaranteed Return",
          key: "bidbond_no",
          width: 200,
          align: "center",
          scopedSlots: { customRender: "bidbond_no" },
          sorter: (a, b) => a.bidbond_no - b.bidbond_no,
        },
      ];
      return kolom;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading = true;
      this.$store
        .dispatch("getManifestBidBondRequest", { auth: this.getAuth, id: this.id })
        .then((response) => {
          try {
            this.data = {
              header: response.header[0],
              related_document: response.dokumen_terkait,
              last_status: response.last_status,
              status: response.status_app,
              bukti_transfer: response.buktiTransfer,
              jenis: response.jenis,
              aksi: response.aksi,
              buktiTransferMasuk: response.buktiTransferMasuk,
              document_pp: response.document_pp,
            };
            this.status_transfer = response.status_transfer;
            this.sisa_tf = response.sisa_tf_keluar;
            this.temp_sisa_tf = this.sisa_tf;
            this.tableData = response.detil;
            this.tableDataTemp = response.detil;
            this.modalPP.listPP = response.list_pp;

            this.checktoDisabledUpload();

            this.loading = false;
          } catch (err) {
            this.loading = false;
            this.displayMessageValue("error", err);
            this.$router.go(-1);
          }
        }).catch((err) => {
          let responses = Object.assign({}, err.response.data);
          if (responses.message && responses.status == false) {
            this.displayMessageValue("error-other", responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
          this.fetch();
        });
    },
    handlePreview(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.formTransfer.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      if (this.data.jenis === "Transfer") {
        this.handleActionTransfer();
      } else {
        this.handleActionAprove();
      }
    },
    handleActionAprove() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan ? values.catatan : "");

        this.loadingSave = true;
        const payload = formData;
        this.$store
          .dispatch("approvalManifestbidBondRequest", { auth: this.getAuth, payload })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessageValue("success-other", response.message);
            this.$router.go(0);
          }).catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            if (responses.status == false && responses.message) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
          });
      });
    },
    handleActionTransfer() {
      this.formTransfer.validateFields((err, values) => {
        if (err) {
          return;
        }
        let formData = new FormData();
        formData.append("id_manifest", this.data.header.bidbond_request_id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan);

        if (this.checkTransferValue) {
          formData.append("cek_value", 1);
          //formData.append("value_transfer", 0);
          formData.append("value_transfer", values.value_transferan);
        } else {
          formData.append("cek_value", 0);
          formData.append("value_transfer", values.value_transferan);
        }
        formData.append(
          "tgl_transfer",
          moment(values.tgl_tf).format(this.getStandartFormatDate)
        );
        formData.append("file_transfer", values.file_transfer.file);

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "bidbond_request/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handleViewDt(file) {
      let tipe = file.url.substr(file.url.length - 3);
      if (tipe == "jpg" || tipe == "jpeg" || tipe == "png") {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      } else {
        window.open(this.$serviceUrl + file.url, "_blank");
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleUploadDoc() {
      if (
        this.$refs.attachmentForm.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }

          if (this.attachmentForm.value == 0) {
            this.displayMessageValue('error-other', 'Please Input Value!')
            return;
          }

          let totalevidence = _.sumBy(this.data.buktiTransferMasuk, function (val) {
            return Number(val.value_tf);
          })

          if (totalevidence + Number(this.attachmentForm.value) > Number(this.data.header.nominal)) {
            this.displayMessageValue('error-other', 'Total value Transfered must be less then or equals to total nominal Request Guarantee!')
            return;
          }

          this.attachmentForm.loading = true;

          let formData = new FormData();
          formData.append("tlc", this.getAuth.username);
          formData.append("bidbond_request_id", this.id);
          formData.append("description", this.attachmentForm.description);
          formData.append("value_transfer", this.attachmentForm.value);
          formData.append("upload_file", this.attachmentForm.file[0]);

          this.attachmentForm.loading = true;
          this.$store
            .dispatch("uploadDocbidbondReq", {
              auth: this.getAuth,
              payload: formData,
            })
            .then((res) => {
              this.attachmentForm = {
                file: [],
                value: null,
                description: "",
              };
              this.attachment = false;
              this.fetchManifest();

              this.attachmentForm.loading = false;
              this.displayMessage("success-upload");
            }).catch((err) => {
              let responses = Object.assign({}, err.response.data);
              if (responses.message && responses.status == false) {
                this.displayMessageValue("error-other", responses.message);
              } else {
                this.displayMessageValue("error", responses);
              }
            });
        })
      );
    },
    uploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.attachmentForm.file = [];
        this.attachmentForm.file = [...this.attachmentForm.file, file];
        return false;
      }
    },
    onRemoveAttachment() {
      this.attachmentForm.file = [];
    },
    checktoDisabledUpload() {
      //hitung  nominal == jumlahNominalUpload ? uploadDisabled
      this.disabledUpload = !(this.data.header.type == "As Companion" && this.getAuth.divisi[0] == "Marketing" &&
        (Number(this.data.header.nominal) > _.sumBy(this.data.buktiTransferMasuk, function (val) {
          return Number(val.value_tf);
        })) && this.data.status[0].status == 'Approved')
    },
    handleEdit() {
      this.$router.push({
        name: "bidBondRequest-edit-mar",
        params: { id: this.id, type: "revised" },
      });
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "bkk") {
        manifest = "bkkManifestKeu";
        const route = this.$router.resolve({
          name: manifest,
          params: { id: id_ },
        });
        window.open(route.href, "_blank");
      } else if (jenis == "bidbond") {
        manifest = "bidBond-manifestKeu";
        const route = this.$router.resolve({
          name: manifest,
          params: { id: id_ },
        });
        window.open(route.href, "_blank");
      }
    },
    showModalAddPP(e) {
      e.stopPropagation();
      this.modalPP.visible = true
    },
    unShowModalAddPP() {
      this.modalPP.visible = false
    },
    inputppValue() {

    },
    saveModalAddPP() {
      if (!this.modalPP.ppValue) {
        this.displayMessageValue("error-other", "No PP Can't be empty!");
      } else {
        let data = new FormData();
        data.append("pp_id", this.modalPP.ppValue.id_pp);
        data.append("bidbond_request_id", this.id);
        this.modalPP.loadingSave = true;
        this.asyncAxiosPost("Bidbond_request/input_document_pp", "formdata", this.getAuth, data)
          .then(() => {
            this.displayMessage("success-save");
            this.modalPP.loadingSave = false;
            this.modalPP.visible = false
            setTimeout(
              function () {
                this.$router.go(0);
              }.bind(this),
              1000
            );
          })
          .catch(() => {
            this.modalPP.loadingSave = false;
            this.modalPP.visible = false
          });
      }
    }
  },
  mounted() {
    this.fetchManifest();
    this.form = this.$form.createForm(this);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.formTransfer = this.$form.createForm(this);
        this.reqFileTf = true;
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
      }
    },
    search() {
      if (this.search) {
        this.tableData = this.tableDataTemp.filter(
          (obj) =>
            obj.companion_nm.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.contact_person.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.return_dt.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.bidbond_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.note.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            // moment(obj.create_dt, "DD-MM-YYYY")
            //   .format("DD-MM-YYYY")
            //   .toString()
            //   .toLowerCase()
            //   .indexOf(this.search.toLowerCase()) >= 0
            obj.type_dtl.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.type_companion.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            (this.formatCurrency('IDR', obj.nominal)).toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }
    }
  },
};
</script>

<style></style>
